function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2775 48.0156V24.9858H0V43.0156C0 45.7771 2.23858 48.0156 5 48.0156H23.2775Z",
  fill: "#18A43B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2775 48.0156H43C45.7614 48.0156 48 45.777 48 43.0156V24.9858H25.2775V48.0156Z",
  fill: "#18A43B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 22.9858V5.01562C48 2.2542 45.7614 0.015625 43 0.015625H25.2775V22.9858H48Z",
  fill: "#18A43B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2775 0.015625H5C2.23858 0.015625 0 2.2542 0 5.01563V22.9858H23.2775V0.015625Z",
  fill: "#18A43B"
});

var Svg4CActive = function Svg4CActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4CActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4c_active.3c7d248e.svg";
export { ForwardRef as ReactComponent };